import { useEffect, useState } from "react";

import classNames from "classnames";

import usePrevious from "../../hooks/usePrevious";

import style from "./ToolButton.module.css";

interface ToolButtonProps extends React.HTMLProps<HTMLDivElement> {
  icon: string;
  isActive?: boolean;
  shouldShowLabel?: boolean;
  label?: string;
  activeLabel?: string;
}

export const ToolButton: React.FC<ToolButtonProps> = ({
  icon,
  isActive,
  shouldShowLabel,
  label,
  activeLabel,
  ...props
}) => {
  const previousActive = usePrevious(isActive);
  const [hasUsedTool, setHasUsedTool] = useState(false);

  useEffect(() => {
    if (!hasUsedTool && previousActive) {
      setHasUsedTool(true);
    }
  }, [hasUsedTool, previousActive]);

  return (
    <div
      {...props}
      className={classNames(style.buttonWrapper, props.className, isActive && style.active)}
      role="button"
    >
      <div
        className={classNames(style.buttonInside)}
        style={{ backgroundImage: `url(${icon})`, backgroundRepeat: "no-repeat" }}
      />
      {shouldShowLabel && !hasUsedTool && (
        <div className={style.buttonLabelWrapper}>
          <div className={classNames(style.buttonLabel)}>{isActive ? activeLabel : label}</div>
        </div>
      )}
    </div>
  );
};
